__turbopack_context__.v({
  "answerInner": "style-module-scss-module__GQd9GG__answerInner",
  "answerPadding": "style-module-scss-module__GQd9GG__answerPadding",
  "answerWrap": "style-module-scss-module__GQd9GG__answerWrap",
  "answerWrapOpen": "style-module-scss-module__GQd9GG__answerWrapOpen",
  "component": "style-module-scss-module__GQd9GG__component",
  "iconBlue": "style-module-scss-module__GQd9GG__iconBlue",
  "iconGold": "style-module-scss-module__GQd9GG__iconGold",
  "iconGreen": "style-module-scss-module__GQd9GG__iconGreen",
  "iconPurple": "style-module-scss-module__GQd9GG__iconPurple",
  "iconRed": "style-module-scss-module__GQd9GG__iconRed",
  "list": "style-module-scss-module__GQd9GG__list",
  "questionIcon": "style-module-scss-module__GQd9GG__questionIcon",
  "questionText": "style-module-scss-module__GQd9GG__questionText",
  "row": "style-module-scss-module__GQd9GG__row",
  "rowHeader": "style-module-scss-module__GQd9GG__rowHeader",
  "rowHeading": "style-module-scss-module__GQd9GG__rowHeading",
  "rowOpen": "style-module-scss-module__GQd9GG__rowOpen",
  "staticProse": "style-module-scss-module__GQd9GG__staticProse",
  "toggleBarH": "style-module-scss-module__GQd9GG__toggleBarH",
  "toggleBarV": "style-module-scss-module__GQd9GG__toggleBarV",
  "toggleBarVOpen": "style-module-scss-module__GQd9GG__toggleBarVOpen",
  "toggleIcon": "style-module-scss-module__GQd9GG__toggleIcon",
});
